import { IResponsive } from '../types/IResponsive';
import { IResponsiveClassNames } from '../types/IResponsiveClassNames';
import { SCREEN_SIZES } from '../types/SCREEN_SIZES';

import { getResponsiveFallback } from './getResponsiveFallback';

export function getResponsiveClassNames<TType extends string | number | symbol> (
    responsive: IResponsive<TType>,
    responsiveClassNames: IResponsiveClassNames<TType>,
): string {
    const classNames: string[] = [];
    const sm: TType | undefined = getResponsiveFallback(responsive, 'sm');
    const md: TType | undefined = getResponsiveFallback(responsive, 'md');
    const lg: TType | undefined = getResponsiveFallback(responsive, 'lg');

    if (sm !== undefined) {
        classNames.push(responsiveClassNames[SCREEN_SIZES.SMALL][sm]);
    }

    if (md !== undefined) {
        classNames.push(responsiveClassNames[SCREEN_SIZES.MEDIUM][md]);
    }

    if (lg !== undefined) {
        classNames.push(responsiveClassNames[SCREEN_SIZES.LARGE][lg]);
    }

    return classNames.join(' ');
}
